import {Feature, Features} from "../feature";
import {extractorUtil} from "../util/extractorUtil";

export const epoxideFilter = {
    filterInPlace: (features: Feature[]) => {
        const ethers = features.filter(f => f.name === Features.ether)
        const ring3s = features.filter(f => f.name === `${Features.ring}.3`);

        // Ethers in a ring.3 are called epoxides.
        ring3s.forEach(r => {
            const ethersInThisRing = ethers.filter(ether => extractorUtil.areHeavyAtomsInRing(ether.atoms, r.atoms))
            if(ethersInThisRing.length > 0) {
                ethersInThisRing.forEach(ether => features.splice(features.indexOf(ether), 1));
                r.name = Features.epoxide;
            }
        })
    }
}